import {useState} from 'react';
import EyeOpLogo from '~/assets/svgs/eye-op.svg?react';
import useHospitalInfo from '~/hooks/useHospitalInfo';
import LeaveBookingModal from '~/modules/booking/components/LeaveBookingModal';
import {BookingDataUpdater, BookingView} from '~/modules/booking/types';

interface HeaderProps {
  setBookingData?: BookingDataUpdater;
  setActiveView?: React.Dispatch<React.SetStateAction<BookingView>>;
}

function Header(props: HeaderProps) {
  const {setActiveView, setBookingData} = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {hospitalInfo} = useHospitalInfo();

  const hospitalURL = hospitalInfo?.moreInfoURL;

  const handleLeave = () => {
    setIsModalOpen(false);
    if (setBookingData && setActiveView) {
      setBookingData(() => ({}));
      setActiveView(BookingView.AppointmentSelectionView);
    }
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const handleOpen = () => {
    setIsModalOpen(true);
  };

  const handleHospitalLogoClick = () => {
    window.open(hospitalURL, '_blank');
  };

  return (
    <div className="flex justify-between items-center px-6 lg:px-20">
      <EyeOpLogo
        className="w-14 h-full aspect-square"
        onClick={handleOpen}
        data-testid="eyeop-logo"
      />
      {hospitalInfo?.mobileLogoURL && (
        <img
          src={hospitalInfo.mobileLogoURL}
          className="w-12 h-full aspect-square block lg:hidden cursor-pointer"
          onClick={handleHospitalLogoClick}
          data-testid="hospital-mobile-logo"
          alt="Hospital Mobile Logo"
        />
      )}
      {hospitalInfo?.textLogoURL && (
        <img
          src={hospitalInfo.textLogoURL}
          className="w-44 h-full hidden lg:block cursor-pointer"
          onClick={handleHospitalLogoClick}
          data-testid="hospital-logo"
          alt="Hospital Logo"
        />
      )}

      {setBookingData && setActiveView && (
        <LeaveBookingModal
          open={isModalOpen}
          onClose={handleClose}
          onLeave={handleLeave}
        />
      )}
    </div>
  );
}

export default Header;
